require("!!C:\\projects\\truBooking\\vendor-admin-portal\\node_modules\\script-loader\\addScript.js")(require("!!C:\\projects\\truBooking\\vendor-admin-portal\\node_modules\\raw-loader\\index.js!C:\\projects\\truBooking\\vendor-admin-portal\\node_modules\\moment\\min\\moment.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/moment/min/moment.min.js
// module id = 705
// module chunks = 2